import { WithStyles, withStyles, Button, Grid, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import _ from 'lodash';
import CourseCard from "./CourseCard";
import {Package,Version} from '../types/interfaces/CourseBasicDetails';
import CourseCardForRequest from './CourseCardForRequest';

interface CourseCardListProps {
  packages: Package[],
  fromCourseRequestTab?: boolean
}
interface CourseCardListState {
}

class CourseCardList extends Component<
CourseCardListProps,
CourseCardListState
> {
  constructor(props: CourseCardListProps) {
    super(props);
    this.state = {
    
      searchText:'',
      openRequestPop:false,
     
    };
  }

  componentDidMount(){
  }
componentDidUpdate(prevProps:CourseCardListProps){

}

  render() {
//  Add UI for Course Lists accordingly  and for one course card add style in courseCard.
    const { packages, fromCourseRequestTab } = this.props;
    return (
      <>
      <div>
        {
            packages.map((course: Package) => {
              return (fromCourseRequestTab ? <CourseCardForRequest packageDetails={course} key={course._id} /> : <CourseCard course={course} key={course._id} />)
            })
        }
      </div>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
	},
	dispatch
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(CourseCardList);
